import { render, staticRenderFns } from "./PassportTemplatesForm.vue?vue&type=template&id=11184ebf&"
import script from "./PassportTemplatesForm.vue?vue&type=script&lang=js&"
export * from "./PassportTemplatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports